import { Pair, Specific, StoredUserConfig } from './types'
import { randomUUID } from './uuid'
import { userConfigKey } from './constant'
import { fetchApi } from './fetch-api'

const storage: Storage | undefined =
  window.localStorage || window.sessionStorage

const storeUserConfig = ({
  appId,
  userId,
  visitorId = randomUUID(),
}: {
  appId: string
  userId?: string
  visitorId?: string
}): StoredUserConfig => {
  const _c = {
    visitorId,
    userId,
  }

  if (storage) {
    const storedUserConfig = storage.getItem(userConfigKey)

    try {
      if (storedUserConfig) {
        const parsedConfig = JSON.parse(storedUserConfig)
        parsedConfig[appId] = _c
        storage.setItem(userConfigKey, JSON.stringify(parsedConfig))
      } else {
        storage.setItem(userConfigKey, JSON.stringify({ [appId]: _c }))
      }
    } catch (e) {
      storage.setItem(userConfigKey, JSON.stringify({ [appId]: _c }))
    }
  }

  return _c
}

export const getUserConfig = (appId: string) => {
  let _config: undefined | StoredUserConfig

  if (storage) {
    const storedUserConfig = storage.getItem(userConfigKey)

    if (!storedUserConfig) {
      _config = storeUserConfig({ appId })
    } else {
      try {
        const parsedConfig = JSON.parse(storedUserConfig)
        if (parsedConfig[appId] && parsedConfig[appId].visitorId) {
          _config = parsedConfig[appId]
        } else {
          _config = storeUserConfig({ appId })
        }
      } catch (e) {
        _config = storeUserConfig({ appId })
      }
    }
  }

  return _config || storeUserConfig({ appId })
}

export const setUserId = ({
  appId,
  userId,
  visitorId,
  instance,
}: {
  appId: string
  userId?: string
  visitorId?: string
  instance: Specific
}) => {
  const _visitorId = visitorId || getUserConfig(appId).visitorId

  instance.userId = userId
  instance.visitorId = _visitorId

  return storeUserConfig({
    appId,
    userId,
    visitorId: _visitorId,
  })
}

export const pairVisitorAndUserIdIfNecessary = async ({
  userId,
  appId,
}: {
  userId: string
  appId: string
}) => {
  const userConfig = getUserConfig(appId)

  if (userConfig.userId !== userId && userId) {
    let visitorId = userConfig.visitorId

    if (userConfig.userId) {
      visitorId = randomUUID()
    }

    const { user } = await fetchApi<Pair>({
      url: `/pair`,
      method: 'POST',
      appId,
      userId,
      visitorId,
    })

    return storeUserConfig({
      appId,
      userId: user.id || undefined,
      visitorId: user.visitorId,
    })
  }
}
